import moment from 'moment'
import { createSelector } from 'reselect'

const _updateLogEvents = state => state.debug.updateLog.data

export const updateLogDone = state => state.debug.updateLog.isDone
export const updateLogError = state => state.debug.updateLog.hasError
export const updateLogPending = state => state.debug.updateLog.isPending

export const updateLogEvents = createSelector(
  [_updateLogEvents],
  events => {
    return events.slice(0, 20).sort((a, b) => {
      return moment.utc(b.updatedAt).diff(moment.utc(a.updatedAt))
    })
  },
)

export const updateLogNewestEvent = createSelector(
  [updateLogEvents],
  events => (events.length > 0 ? events[0] : null),
)
